import { render, staticRenderFns } from "./MstfAddMainO.vue?vue&type=template&id=5c0d3286&scoped=true&"
import script from "./MstfAddMainO.vue?vue&type=script&lang=js&"
export * from "./MstfAddMainO.vue?vue&type=script&lang=js&"
import style0 from "./MstfAddMainO.vue?vue&type=style&index=0&id=5c0d3286&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0d3286",
  null
  
)

export default component.exports